var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.2834 28.65C32.6167 30.1667 30.4667 31 28.2167 30.9833H28.0666C28.5666 29.95 28.8333 28.7833 28.8333 27.55C28.8333 22.95 25.1 19.2167 20.5 19.2167C15.9 19.2167 12.1667 22.95 12.1667 27.55C12.1667 28.7833 12.4334 29.95 12.9334 30.9833H9.7333C1.9333 30.4333 1.9333 19.0833 9.7333 18.5333H9.81671C4.46671 3.65001 27.0333 -2.29999 29.6166 13.3333C36.8333 14.25 39.75 23.8667 34.2834 28.65Z",
    fill: "#B14949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 19.2167C15.9001 19.2167 12.1667 22.95 12.1667 27.55C12.1667 28.7833 12.4335 29.95 12.9335 30.9833C13.0668 31.2833 13.2167 31.5667 13.3834 31.8333C14.8167 34.25 17.4667 35.8833 20.5001 35.8833C23.5334 35.8833 26.1834 34.25 27.6168 31.8333C27.7834 31.5667 27.9334 31.2833 28.0667 30.9833C28.5667 29.95 28.8334 28.7833 28.8334 27.55C28.8334 22.95 25.1001 19.2167 20.5001 19.2167ZM23.9501 26.8333L20.4001 30.1167C20.1668 30.3333 19.8501 30.45 19.5501 30.45C19.2334 30.45 18.9168 30.3333 18.6668 30.0833L17.0167 28.4333C16.5334 27.95 16.5334 27.15 17.0167 26.6667C17.5 26.1833 18.3 26.1833 18.7834 26.6667L19.5834 27.4667L22.2501 25C22.7667 24.5333 23.5501 24.5667 24.0167 25.0667C24.4834 25.5667 24.4501 26.35 23.9501 26.8333Z",
    fill: "#B14949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAddIcon);
export default __webpack_public_path__ + "static/media/cloud-add-icon.ef57e6acc912de08c13a991581dbf406.svg";
export { ForwardRef as ReactComponent };